import { z } from "zod";
import { transactionTypes } from "../../../units";

/**
 * One hand-booked carrier movement: sixty pallets arrived, twelve came back broken, the yard
 * count was wrong by three.
 *
 * `operation` is separate from a signed quantity because the ledger stores it that way — the
 * balance trigger reads `ADD`/`REMOVE` and a negative quantity would sail past it unnoticed.
 * `type` is why the movement happened, and every reason the enum carries applies to a carrier
 * except `pick`, which the picking round writes for itself.
 */
export const postLoadCarrierTransactionJsonSchema = z.object({
	operation: z.enum(["ADD", "REMOVE"]),
	quantity: z.coerce.number().int().positive(),
	type: z.enum(transactionTypes),
});

export type PostLoadCarrierTransactionJsonSchema = z.infer<
	typeof postLoadCarrierTransactionJsonSchema
>;
